"use client";
import ElectoralDistrictSection from "@/components/sections/landing/electoral-district/electoralDistrictSection";
import HeroSection from "@/components/sections/landing/heroSection";
import MemberOverviewSection from "@/components/sections/landing/memberOverviewSection";
import NewsSection from "@/components/sections/landing/news/newsSection";
import React, { useEffect } from "react";
import Cookie from "js-cookie";
import { useRouter, useSearchParams } from "next/navigation";
import { decodedProps } from "@/types";
import { jwtDecode } from "jwt-decode";
import { useQueryClient } from "@tanstack/react-query";

const Landing = () => {
  const router = useRouter();
  const params = useSearchParams();
  const queryClient = useQueryClient();

  const tokenGoogle = params.get("token");
  const callback = params.get("callback");

  useEffect(() => {
    if (tokenGoogle) {
      Cookie.set("accessToken", tokenGoogle);
      const decode: decodedProps = jwtDecode(tokenGoogle);
      if (callback) {
        return router.push(callback);
      }
      if (decode.role === "user") {
        queryClient.invalidateQueries({ queryKey: ["useGetProfile"] });
      } else {
        router.push("/dashboard");
      }
    }
  }, [tokenGoogle, router, callback, queryClient]);

  return (
    <main className="overflow-hidden">
      <HeroSection />
      <MemberOverviewSection />
      <ElectoralDistrictSection />
      <NewsSection />
    </main>
  );
};

export default Landing;
